import React from 'react'
import './Bace.css'
function Bace() {
  return (
    <>
    <div className="container-fluid px-0">
      <img
        src="/assets/bace_banner.jpg"
        alt="Bace Banner"
        className="img-fluid"
      />
    </div>
    <div class="container-fluid mt-5 bace_heading" data-aos="fade-up">
        <div class="row">
            <div class="col-md-6 d-flex flex-column justify-content-center text-center ">
                <h2>Our Spiritual Bace</h2>
                <p>
                At Bace, we blend Krishna consciousness with academics, supporting students in both their studies and spiritual paths. Following the Bhagavad Gita, we help them thrive intellectually and spiritually.
                </p>
                <p><strong>Spiritually enriched, academically empowered.</strong> </p>
            </div>
            <div class="col-md-6 prabhupada">
                <img src="/assets/prabhupada.png" class="img-fluid" alt="Krishna Consciousness" />
                <p className='text-center'><strong>A. C. Bhaktivedanta Swami Prabhupada</strong><br />(founder acharya of ISKCON)</p>
            </div>
        </div>
    </div>
    <div class="container mt-5 bace_heading" data-aos="fade-up">
    <div class="row">
        <div class="col-md-12">
            <h2 class="text-center">Why Choose Bace?</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class='text-center'>
                <h4>सतां प्रसङ्गान्मम वीर्यसंविदो
                    भवन्ति हृत्कर्णरसायना: कथा:।<br />
                    तज्जोषणादाश्वपवर्गवर्त्मनि
                    श्रद्धा रतिर्भक्तिरनुक्रमिष्यति ॥ ३.२५.२५ ॥</h4>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <p class="text-center">In the association of pure devotees, discussion of the pastimes and activities of the Supreme Personality of Godhead is very pleasing and satisfying to the ear and the heart. By cultivating such knowledge one gradually becomes advanced on the path of liberation, and thereafter he is freed, and his attraction becomes fixed. Then real devotion and devotional service begin.</p>
        </div>
    </div>
</div>
<div class="container mt-5" >
  <div class="grid-container">
    <div class="grid-item">
      <img src="/assets/bace_b1.jpg" alt="Image 1"/>
      <div class="overlay">
        <div class="overlay-content bace_heading">
          <h4 class="d-none d-md-block ">Spiritual growth: the gateway to inner peace and purposeful living.</h4>
        </div>
      </div>
    </div>
    <div class="grid-item">
      <img src="/assets/bace_b2.jpg" alt="Image 2"/>
      <div class="overlay">
        <div class="overlay-content bace_heading">
          <h4 class="d-none d-md-block">Alumni connections: fostering collaboration, growth, and lifelong bonds.</h4>
        </div>
      </div>
    </div>
    <div class="grid-item">
      <img src="/assets/bace_b3.jpg" alt="Image 3"/>
      <div class="overlay">
        <div class="overlay-content bace_heading">
          <h4 class="d-none d-md-block">Family-like care: where love and support flourish.</h4>
        </div>
      </div>
    </div>
    <div class="grid-item">
      <img src="/assets/bace_b4.jpg" alt="Image 4"/>
      <div class="overlay">
        <div class="overlay-content bace_heading">
          <h4 class="d-none d-md-block">Reasonable accommodation: ensuring accessibility and inclusivity for all.</h4>
        </div>
      </div>
    </div>
  </div>
</div>

<div className="container mt-5 bace_heading">
      <h2 className="mt-4 text-center">Bace Life & Youth Camps</h2>
      <p className="mb-4 text-center">Check out our amazing Bace Life and various Youth Camps</p>
      <div id="carouselExample" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="3000">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src="/assets/bace_b5.jpeg" className="d-block w-100" alt="Slide 1"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_b7.jpeg" className="d-block w-100" alt="Slide 2"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_b6.jpeg" className="d-block w-100" alt="Slide 3"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_b12.jpeg" className="d-block w-100" alt="Slide 4"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_b14.jpeg" className="d-block w-100" alt="Slide 5"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_b17.jpeg" className="d-block w-100" alt="Slide 6"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_b18.jpeg" className="d-block w-100" alt="Slide 7"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_b8.jpeg" className="d-block w-100" alt="Slide 8"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_b10.jpeg" className="d-block w-100" alt="Slide 9"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_b19.jpeg" className="d-block w-100" alt="Slide 10"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_25.jpeg" className="d-block w-100" alt="Slide 11"/>
          </div>
          <div className="carousel-item">
            <img src="/assets/bace_26.jpeg" className="d-block w-100" alt="Slide 12"/>
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>  
    
    
    <div class="container mt-1 bace_heading text-center" data-aos="zoom-in">
    <h2 className="text-center mt-5 mb-0">Visit Temple</h2>
    <p>Our temple hall is a spiritual oasis where devotees worship Lord Jagannath, Baldev, and Subhadra Ji amidst chanting, kirtan, and a deeply positive atmosphere.</p>
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="img-container">
                    <img src="/assets/bace_b20.jpeg" class="img-fluid" alt="Responsive Image" />
                </div>
            </div>
        </div>
    </div>
    <div class="container my-5 bace_heading">
  <div class="row justify-content-center text-center">
    <div class="col-md-8">
      <h2 class="text-center mb-4">Daily Morning Program</h2>
      <div class="row">
        <div class="col-6 text-right font-weight-bold"><h2>time</h2></div>
        <div class="col-6 text-left font-weight-bold"><h2>activity</h2></div>
      </div>
      <div class="row border-top py-2">
        <div class="col-6 text-right"><p>5:00 AM</p></div>
        <div class="col-6 text-left">Mangala Aarti</div>
      </div>
      <div class="row border-top py-2">
        <div class="col-6 text-right"><p>5:30 AM</p></div>
        <div class="col-6 text-left">Tulsi Puja</div>
      </div>
      <div class="row border-top py-2">
        <div class="col-6 text-right"><p>6:00 AM</p></div>
        <div class="col-6 text-left">Japa Meditation</div>
      </div>
      <div class="row border-top py-2">
        <div class="col-6 text-right"><p>7:30 AM</p></div>
        <div class="col-6 text-left">Darshan Aarti</div>
      </div>
      <div class="row border-top py-2">
        <div class="col-6 text-right"><p>7:45 AM</p></div>
        <div class="col-6 text-left">Daily morning class</div>
      </div>
    </div>
  </div>
</div>
<div class="container mt-5 services" data-aos="zoom-in">
  <h1 class="text-center ">Regular Programs & Visits</h1>
  <p className='services'>Nest Jabalpur's regular programs encompass in-depth Bhagavad Gita studies, leadership development initiatives, and visits to sacred sites like Vrindavan and Mayapur, providing a holistic experience for personal and spiritual growth.</p>
  <div class="row">
    <div class="col-lg-3 col-md-6" data-aos="fade-up" >
      <div class="box d-flex flex-column align-items-center">
        <img src="/assets/bace_b21.jpeg" class="img-fluid" alt="Team Member 1" />
        <h3 class="text-center mt-3 services">Journey of Self Discovery</h3>
        
      </div>
    </div>
    <div class="col-lg-3 col-md-6" data-aos="fade-up" >
      <div class="box d-flex flex-column align-items-center">
        <img src="/assets/bace_b22.jpeg" class="img-fluid" alt="Team Member 2" />
        <h3 class="text-center mt-3">Shree Ram Janmotsava</h3>
        
      </div>
    </div>
    <div class="col-lg-3 col-md-6" data-aos="fade-up" >
      <div class="box d-flex flex-column align-items-center">
        <img src="/assets/bace_b23.jpeg" class="img-fluid" alt="Team Member 3" />
        <h3 class="text-center mt-3">Farewell <br />Camp</h3>
        
      </div>
    </div>
    <div class="col-lg-3 col-md-6" data-aos="fade-up" >
      <div class="box d-flex flex-column align-items-center">
        <img src="/assets/bace_b24.jpeg" class="img-fluid" alt="Team Member 4" />
        <h3 class="text-center mt-3">Advance Bhagwat Geeta</h3>
        
      </div>
    </div>
    
  </div>
</div>
<div className="container bace_heading ">
  <h2 className="text-center mt-5 mb-2">Frequently Asked Question</h2>
  <div class="accordion accordion-flush" id="accordionFlushExample">
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
          What is BACE?
        </button>
      </h2>
      <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
        <div class="accordion-body answer-text">BACE stands for Bhaktivedanta Academy for Culture & Education. Its primary objective is to train the young boys, who are the future of the society, in real culture and education.Nowadays everyone is enamored by western culture where man and woman are free to do anything they like. Everyone's goal of life is to accumulate more money and make the life more aristocratic and comfortable with the latest technology available.</div>
      </div>
    </div>

    <div class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
          What kind of people are there in the BACE?
        </button>
      </h2>
      <div id="flush-collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
        <div class="accordion-body answer-text">The members of BACE are mostly bright young boys who are either working professionals or college students. They spend working hours/college hours in office/college, but utilize the free time in studying Vedic literature and practicing Krishna consciousness.</div>
      </div>
    </div>

    <div class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
          What benefits will I get if I join the BACE?
        </button>
      </h2>
      <div id="flush-collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
        <div class="accordion-body answer-text">Joining the BACE offers unparalleled academic support and spiritual growth, helping you excel in your studies while nurturing your personal and ethical development. This holistic approach ensures you advance in every field, equipping you with the knowledge and values needed for success in all aspects of life.</div>
      </div>
    </div>

    <div class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
          How can I join the BACE?
        </button>
      </h2>
      <div id="flush-collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
        <div class="accordion-body answer-text">You simply have to come to the program at any nearby BACE and enroll yourself for the training sessions. You need not pay any money but you are expected to be sincere about the life and honest in your words. If you really want to get the benefit, you need to be regular in the programs but there is no hard and fast rule that you must attend every program.</div>
      </div>
    </div>

    <div class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
          I don't believe in God and religion. Can I attend the program and ask questions?
        </button>
      </h2>
      <div id="flush-collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
        <div class="accordion-body answer-text">Yes. Human life is meant to enquire the problems and solve them. One need not believe in the existence of God blindly and one should not believe God just to receive some material benefits like money, job etc. An intelligent human being is expected to ask questions on various problems of life.</div>
      </div>
    </div>
  </div>
</div>
 </>
  )
}

export default Bace
